import { render, staticRenderFns } from "./newEditCandidateDetailsDialog.vue?vue&type=template&id=0de1eac6&"
import script from "./newEditCandidateDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./newEditCandidateDetailsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports